import InviteUsersModal from "./InviteUsersModal/InviteUsersModal";

export default InviteUsersModal;
